<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-if="!modoEdicao" class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item">
                <SimSelect v-model:idSelecionado="idLocalidade" @update:objSelecionado="atualizaSim" />
            </div>
                
            <button type="button" class="buttom-icon--edit" @click="setEdicao" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
         </div>
    </div>


    <div v-else>
        <div class="form-edit-page row-space">
            <div class="row">
                <div class="form-item">
                    <label class="label-caption">SIM</label>
                    <div class="field-label">{{ simSelecionado.nmsim }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Município</label>
                    <div class="field-label">{{ `${simSelecionado.nmmunicipio} / ${simSelecionado.uf}` }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Fone</label>
                    <div class="field-label field-label-center">{{ simSelecionado.fone }}</div>
                </div>
            </div>
        </div>

        
        <div class="form-panel row-space">
            <div class="form-panel-header">GERENCIAMENTO DE INSPETORES</div>
            <div class="form-panel-body">
                <div class="row row-space">
                    <InspetorSelect v-model:idSelecionado="idInspetor" />

                    <div class="form-item-char20">
                        <label class="label-caption">Horas</label>
                        <input type="text" class="input-right" v-model="edTtHoras" maxlength="4" v-decimal />
                    </div>

                    <button type="button" class="buttom-icon--add" @click="incluirInspetor" />
                    <button type="button" class="buttom-icon--close" @click="modoEdicao=false" />
                </div>
            </div>
        </div>


        <div v-if="lsDados.length > 0" class="table-wrapper"><table>
            <thead><tr>
                <th>Inspetores Vinculados ao SIM</th>
                <th>Fone</th>
                <th>Registro/Órgão</th>
                <th>Registro/Número</th>
                <th>Situação</th>
                <th>Horas</th>
                <th></th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td>{{ obj.nmusuario }}</td>
                    <td class="col-width-char15 center">{{ obj.celular }}</td>
                    <td class="col-width-char15">{{ obj.registro_orgao }}</td>
                    <td class="col-width-char15 center">{{ Funcoes.formatInteger(obj.registro_numero) }}</td>
                    <td class="col-width-char15">{{ obj.xativo }}</td>
                    <td class="col-width-char15 center">{{ Funcoes.formatDecimal(obj.tthoras) }}</td>
                    <td class="col-width-char05"><div class="row-center">
                        <button class="btn-icon btn-icon--trash" @click="abrirModal(obj)"></button>
                    </div></td>
                </tr>
            </tbody>
        </table></div>
    </div>
    

    <ConfirmModal ref="confirmModal" />
</template>
  
<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import InspetorSelect from '@/selects/InspetorSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const confirmModal = ref(null)
const emit=defineEmits(['close', 'save'])

const edTtHoras = ref(null);
const modoEdicao = ref(false);
const msgAlerta = ref(false);
const idInspetor = ref(0);
const idLocalidade = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const simSelecionado = ref({});


async function abrirModal(obj) {
    const confirmado = await confirmModal.value.show({
        message: `Confirma exclusão do inspetor "${obj.nmusuario}"?`,
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        excluiInspetor(obj);  
    }
}


function atualizaSim(obj) {
    simSelecionado.value = obj;
}


function closeForm(){emit('close')}


async function excluiInspetor(obj){
    try{
        const response = await Api.genericPost('/cad/exec_requisicao', {
            nmrequisicao: 'simbyuser_desabilitar',
            id: obj.id,
            idsim: simSelecionado.value.id,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (response.bolok === 1){
            await lerDados();
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


async function incluirInspetor(){
    try {
        msgAlerta.value=null;
        if (!idInspetor.value){throw new Error('Informe o inspetor')}
        isLoading.value=true;

        const response = await Api.genericPost('/cad/exec_requisicao', {
            nmrequisicao: 'simbyuser_habilitar',
            id: idInspetor.value,
            idsim: simSelecionado.value.id,
            doubleparam1: Funcoes.decimalFromString(edTtHoras.value),
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (response.bolok === 1){
            await lerDados();
            idInspetor.value=0;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function lerDados() {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/sim/inspetores', {
            idsim: simSelecionado.value.id,
            idusuario: globalStore.idusuario });
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


async function setEdicao(){
    if (!simSelecionado.value.id){msgAlerta.value = 'Selecione um serviço de inspeção para iniciar'; return;}
    try{
        msgAlerta.value=null;
        idInspetor.value=0;
        modoEdicao.value=true;
        await lerDados();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
    
}
</script>
